import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { Steps, Step } from 'components/Docs/Steps';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`PostHog's managed reverse proxy routes traffic through our infrastructure. We handle SSL certificates, routing, and maintenance automatically.`}</p>
    <p>{`This option requires our `}<a parentName="p" {...{
        "href": "https://posthog.com/platform-packages"
      }}>{`platforms add-ons`}</a>{` and access to your domain's DNS settings.`}</p>
    <Steps mdxType="Steps">
      <Step title="Create your proxy" mdxType="Step">
        <ol>
          <li parentName="ol">{`Go to `}<a parentName="li" {...{
              "href": "https://app.posthog.com/settings/organization-proxy"
            }}>{`organization proxy settings`}</a></li>
          <li parentName="ol">{`Click `}<strong parentName="li">{`new managed proxy`}</strong></li>
          <li parentName="ol">{`Enter a subdomain you control. For example, if your app runs on `}<inlineCode parentName="li">{`myapp.com`}</inlineCode>{`, use `}<inlineCode parentName="li">{`ph.myapp.com`}</inlineCode></li>
        </ol>
        <p>{`Choose a neutral subdomain that doesn't include words like `}<inlineCode parentName="p">{`analytics`}</inlineCode>{`, `}<inlineCode parentName="p">{`tracking`}</inlineCode>{`, or `}<inlineCode parentName="p">{`posthog`}</inlineCode>{`. Ad blockers target obvious terms.`}</p>
      </Step>
      <Step title="Create a DNS record" mdxType="Step">
        <p>{`Go to your DNS provider and create a new `}<strong parentName="p">{`CNAME record`}</strong>{`:`}</p>
        <ol>
          <li parentName="ol">{`Set the `}<strong parentName="li">{`Name`}</strong>{` to your chosen subdomain (just the subdomain part, like `}<inlineCode parentName="li">{`ph`}</inlineCode>{`)`}</li>
          <li parentName="ol">{`Set the `}<strong parentName="li">{`Target`}</strong>{` to the proxy domain PostHog generated in the previous step. You'll see it in your proxy settings, it looks like `}<inlineCode parentName="li">{`4854cf84789d8596ad01.proxy-us.posthog.com`}</inlineCode></li>
          <li parentName="ol">{`Save the record`}</li>
        </ol>
        <blockquote>
          <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` If you're using Cloudflare, disable proxying on this CNAME record by clicking the cloud icon and set it to `}<strong parentName="p">{`DNS only`}</strong>{`. Cloudflare's proxy interferes with PostHog's SSL certificate provisioning.`}</p>
        </blockquote>
      </Step>
      <Step title="Wait for provisioning" mdxType="Step">
        <p>{`Your proxy status will change from `}<strong parentName="p">{`waiting`}</strong>{` → `}<strong parentName="p">{`issuing`}</strong>{` → `}<strong parentName="p">{`live`}</strong>{`. This typically takes 2-5 minutes but can take up to 30 minutes if DNS propagation is slow.`}</p>
        <p>{`PostHog will automatically detect your DNS record and provision an SSL certificate. No further action needed.`}</p>
        <blockquote>
          <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` If your proxy stays in `}<strong parentName="p">{`issuing`}</strong>{` for more than 30 minutes, see `}<a parentName="p" {...{
              "href": "/docs/advanced/proxy/proxy-reference#troubleshooting"
            }}>{`troubleshooting`}</a>{`.`}</p>
        </blockquote>
      </Step>
      <Step title="Update your PostHog SDK" mdxType="Step">
        <p>{`Update your PostHog initialization to use your new subdomain:`}</p>
        <MultiLanguage mdxType="MultiLanguage">
          <pre><code parentName="pre" {...{
              "className": "language-js",
              "metastring": "file=US",
              "file": "US"
            }}>{`posthog.init('<ph_project_api_key>', {
  api_host: 'https://ph.myapp.com',
  ui_host: 'https://us.posthog.com'
})
`}</code></pre>
          <pre><code parentName="pre" {...{
              "className": "language-js",
              "metastring": "file=EU",
              "file": "EU"
            }}>{`posthog.init('<ph_project_api_key>', {
  api_host: 'https://ph.myapp.com',
  ui_host: 'https://eu.posthog.com'
})
`}</code></pre>
        </MultiLanguage>
        <p>{`Replace `}<inlineCode parentName="p">{`ph.myapp.com`}</inlineCode>{` with your actual subdomain, and provide your `}<strong parentName="p">{`project API key`}</strong>{`.`}</p>
        <p>{`Always set both `}<inlineCode parentName="p">{`api_host`}</inlineCode>{` (your proxy) and `}<inlineCode parentName="p">{`ui_host`}</inlineCode>{` (PostHog's actual domain) so features like the toolbar work correctly.`}</p>
      </Step>
      <Step checkpoint title="Verify your setup" mdxType="Step">
        <p>{`Confirm events are flowing through your proxy:`}</p>
        <ol>
          <li parentName="ol">{`Open your browser's developer tools and go to the `}<strong parentName="li">{`Network`}</strong>{` tab`}</li>
          <li parentName="ol">{`Trigger an event in your app, like a page view`}</li>
          <li parentName="ol">{`Look for a request to your proxy subdomain (e.g., `}<inlineCode parentName="li">{`ph.myapp.com`}</inlineCode>{`)`}</li>
          <li parentName="ol">{`Verify the response is `}<inlineCode parentName="li">{`200 OK`}</inlineCode></li>
          <li parentName="ol">{`Check the `}<a parentName="li" {...{
              "href": "https://app.posthog.com"
            }}>{`PostHog app`}</a>{` to confirm events appear`}</li>
        </ol>
        <p>{`If you see errors or events aren't appearing, see `}<a parentName="p" {...{
            "href": "/docs/advanced/proxy/proxy-reference#troubleshooting"
          }}>{`troubleshooting`}</a>{`.`}</p>
      </Step>
    </Steps>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      